<button *ngIf="!hideButton" iccIconButton appearance="flat-base" [iccMenuTriggerFor]="announcementsMenu">
    <icc-icon name="alert" [iccBadge]="(badge$ | async)" iccBadgeSize="large" iccBadgeAppearance="alert" [iccBadgeHidden]="!(announcements$ | async)?.length"></icc-icon>
</button>


<icc-menu #announcementsMenu="iccMenu" xPosition="before" yPosition="below" class="announcements-menu">
    <div icc-menu-item *ngFor="let message of (announcements$ | async); let i=index; trackBy: byUuid" [ngClass]="['icc-toast-message-' + message.severity]" class="icc-toast-message" [class.icc-toast-message-highlighted]="message.highlighted" (click)="$event.stopPropagation();">
        <div class="icc-toast-message-content" role="alert" aria-live="assertive" aria-atomic="true">
            <icc-icon class="icc-toast-message-icon" [name]="getIcon(message)"></icc-icon>
            <div class="icc-toast-message-text">
                <div class="icc-toast-summary">{{message.title}}</div>
                <div class="icc-toast-detail" [innerHtml]="message.bodyShort"></div>
                <div class="icc-toast-department" *ngIf="message?.departmentName">
                    <p iccBadgeChip appearance='outline'>
                        {{ message?.departmentName }}
                    </p>
                </div>
                <button type="button" iccButton appearance="flat-base" *ngIf="message.hasBodyRichtext" (click)="openMessageDetails(message)">{{ 'INTERFACE|Szczegóły' | translate }}</button>
            </div>
            <button type="button" iccIconButton appearance="flat-base"  class="icc-toast-icon-close p-link" *ngIf="!message.pinned" (click)="onCloseIconClick($event, message)" (keydown.enter)="onCloseIconClick($event, message)">
                <icc-icon name="close"></icc-icon>
            </button>
        </div>
    </div>
    <p *ngIf="(announcements$ | async).length === 0">{{'ANNOUNCEMENT|Brak komunikatów' | translate}}</p>
</icc-menu>
